export default "__VITE_ASSET__DI3O6afZ__"